import React from 'react';
import classnames from 'classnames';
import * as styles from './style.module.scss';

import { Link } from 'gatsby';

import Icon from 'components/UI/Icon';
import Socials from 'components/Elements/Socials';
import DataSocials from '@/mocks/socials';
import { BLOG_PAGE } from '@/constants/pagesUrl';

const Finish = () => (
  <div className={styles.finish}>
    <div className={styles.finish_head}>
      <p className={styles.finish_head_suptitle}>
        <Icon name={'checked-circled'} className={'cr-text-3'} />
        <span className={classnames('cr-subheader-4 cr-text-3')}>
          Request sent
        </span>
      </p>

      <p className={classnames('cr-h3', styles.finish_head_title)}>
        Thank you for your request.
      </p>

      <p className={classnames('cr-reg')}>
        Our team will contact you shortly and answer all of your questions
      </p>
    </div>

    <div className={styles.finish_main}>
      <p
        className={classnames(
          'cr-main cr-subheader-3 cr-txt-up',
          styles.finish_main_title
        )}
      >
        What next
      </p>

      <div className={styles.finish_main_links}>
        <Link to={BLOG_PAGE} className={styles.largelink}>
          <div className={styles.largelink_l}>
            <p className={classnames('cr-lead', styles.largelink_title)}>
              Read our blog
            </p>
            <p className={classnames('cr-reg')}>
              A source of knowledge and inspiration for forwardthinkers
            </p>
          </div>
          <div className={styles.largelink_r}>
            <Icon
              name={'corner-arrow-small-bold'}
              className={classnames('cr-text-3', styles.largelink_arrow)}
            />
          </div>
        </Link>
      </div>
    </div>

    <div className={styles.finish_bot}>
      <p className={classnames('cr-lead', styles.finish_bot_title)}>
        Connect to us
      </p>

      <p className={classnames('cr-reg', styles.finish_bot_desc)}>
        Follow us on social network of your choice
      </p>

      <Socials socials={DataSocials} mod={'black'} />
    </div>
  </div>
);

export default Finish;
